import { render, staticRenderFns } from "./imagenPerfil.vue?vue&type=template&id=378f9491&"
import script from "./imagenPerfil.vue?vue&type=script&lang=js&"
export * from "./imagenPerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports